<template>
    <div class="input-group input-group--dirty input-group--text-field primary--text color-picker" :class="{'input-group--focused': displayPicker}" ref="colorpicker">
      <label v-text="label"></label>
      <div class="input-group-addon color-picker-container">
        <span class="current-color" :style="'background-color: ' + colorValue" @click="togglePicker()"></span>
        <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" />
      </div>
      <input type="text" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" />
      <div class="input-group__details"><div class="input-group__messages"></div></div>
    </div>
</template>

<script>
import { Chrome } from "vue-color";

export default {
  components: {
    "chrome-picker": Chrome
  },
  props: ["color", "label"],
  data() {
    return {
      colors: {
        hex: "#000000"
      },
      colorValue: "",
      displayPicker: false
    };
  },
  mounted() {
    this.setColor(this.color || "#000000");
  },
  methods: {
    setColor(color) {
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      /* eslint no-bitwise: 0 */
      if (color.slice(0, 1) === "#") {
        this.colors = {
          hex: color
        };
      } else if (color.slice(0, 4) === "rgba") {
        const rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(",");
        const hex = `#${((1 << 24) +
          (parseInt(rgba[0], 10) << 16) +
          (parseInt(rgba[1], 10) << 8) +
          parseInt(rgba[2], 10)
        )
          .toString(16)
          .slice(1)}`;
        this.colors = {
          hex,
          a: rgba[3]
        };
      }
    },
    showPicker() {
      this.$parent.$el.addEventListener("click", this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      this.$parent.$el.removeEventListener("click", this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      if (this.displayPicker) {
        this.hidePicker();
      } else {
        this.showPicker();
      }
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      if (color.rgba.a === 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba
          .b}, ${color.rgba.a})`;
      }
    },
    documentClick(e) {
      const el = this.$refs.colorpicker;
      const target = e.target;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    }
  },
  watch: {
    colorValue(val) {
      if (val) {
        this.updateColors(val);
        this.$emit("input", val);
      }
    }
  }
};
</script>
<style scoped>
.vc-chrome {
  position: absolute;
  top: 50px;
  left: 0;
  z-index: 99;
}
.current-color {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: 6px 10px 0 0;
  background-color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/util/ColorPicker.vue